import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: RootLayout,
});

/**
 * One column, phone width, with the page's primary action pushed to the
 * bottom third by the page itself (flex-1 spacer). Wider screens get the
 * same column centred: this is a phone product first.
 */
function RootLayout() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-md flex-col px-5 pb-6 pt-8">
      <Outlet />
    </div>
  );
}
